import { IBatchFields } from 'types/batchFields';

import { CRMAPIBase } from '@api/crmApiBase';
import { RequestResult } from '@api/responseModels/requestResult';

export class BatchGroup extends CRMAPIBase {
    /**
     * Запрос на удаление множества записей
     * @param crmId ID CRM
     * @param model Тип сущности
     * @param ids ID's записей
     * @returns Результат запроса
     */
    async batchDelete(batchFields: IBatchFields): Promise<RequestResult<null>> {
        const result = await this.post<null>('/batch/delete', batchFields);
        return result;
    }

    /**
     * Запрос на восстановление множества записей
     * @param crmId ID CRM
     * @param model Тип сущности
     * @param ids ID's записей
     * @returns Результат запроса
     */
    async batchRestore(batchFields: IBatchFields): Promise<RequestResult<null>> {
        const result = await this.post<null>('/batch/restore', batchFields);
        return result;
    }

    /**
     * Запрос на обновление множества записей
     * @param crmId ID CRM
     * @param model Тип сущности
     * @param ids ID's записей
     * @param [key: string] Обновляемые поля
     * @returns Результат запроса
     */
    async batchUpdate(batchFields: IBatchFields): Promise<RequestResult<null>> {
        const result = await this.post<null>('/batch/update', batchFields);
        return result;
    }
}
